// Mirrors the backend's DE mobile check (004915/16/17, 14–15 digits), which
// validates the number again on save.
const DE_MOBILE_NUMBER = /^00491[567]\d{8,9}$/;

const getInternationalNumber = (number: string) => {
    if (number.startsWith('+49')) return `0049${number.slice(3)}`;
    if (number.startsWith('0049')) return number;
    if (number.startsWith('01')) return `0049${number.slice(1)}`;
    return undefined;
};

/**
 * Returns the number with everything but digits and a leading `+` stripped, or
 * undefined if it isn't a DE mobile number (`+49…`, `0049…` or `01…`).
 */
export const getCleanedDeMobileNumber = (input: string) => {
    const trimmed = input.trim();
    const cleaned = `${trimmed.startsWith('+') ? '+' : ''}${trimmed.replace(/\D/g, '')}`;
    const international = getInternationalNumber(cleaned);

    return international && DE_MOBILE_NUMBER.test(international)
        ? cleaned
        : undefined;
};
